import { render, staticRenderFns } from "./ProfilePreview.vue?vue&type=template&id=ad640740&scoped=true&"
import script from "./ProfilePreview.vue?vue&type=script&lang=js&"
export * from "./ProfilePreview.vue?vue&type=script&lang=js&"
import style0 from "./ProfilePreview.vue?vue&type=style&index=0&id=ad640740&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad640740",
  null
  
)

export default component.exports